import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from '../common/PageTitleBanner';

const ProjectDetail = () => {
    return (
        <>
            <PageTitle subtitle="dolor sit" title="Lorem Ipsum" bannerImage="assets/images/banner.jpg" />
            <div className="breadcrumbs">
                <Container>
                    <ul>
                        <li><Link to="/projects"><em><i className="fa fa-angle-left"></i> Go back to all projects</em></Link></li>
                    </ul>
                </Container>
            </div>
            <section className="content-section pt-0">
                <Container>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="image-wrap mb-5">
                                <img src="https://picsum.photos/600/600" width="100%" alt="" />
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-5 offset-xl-1">
                            <div className="sub-heading mb-4">Know more about!</div>
                            <div className="heading mb-4"><span className="weight-light">Project</span> Detail </div>
                            <div className="para-txt txt-large mb-5">
                                <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
                            </div>
                            <ul className="listul-style">
                                <li><strong>Client:</strong>   Awesome Company</li>
                                <li><strong>Location:</strong>   Mountain View CA 94043</li>
                                <li><strong>Surface Area:</strong> 450,000 m2</li>
                                <li><strong>Year Completed:</strong>   2014</li>
                                <li><strong>Value:</strong> $250.000</li>
                                <li><strong>Architect:</strong>  Jason & Perry</li>
                            </ul>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}
export default ProjectDetail;